import { FC } from 'react'
import { composeClasses } from '../../utils/compose-classes'

export interface GoogleIconProps {
  name: string
  variant?: 'filled' | 'outlined'
  className?: string
  ariaLabel?: string
}

/**
 * @deprecated This component is deprecated and will be removed in the next release. Please use library react-icons.
 */
export const GoogleIcon: FC<GoogleIconProps> = ({
  name,
  variant = 'outlined',
  className,
  ariaLabel
}) => {
  console.warn(
    'GoogleIcon component is deprecated and will be removed in the next release. Please use library react-icons.'
  )
  return (
    <span
      role="img"
      translate="no"
      aria-label={ariaLabel ?? name}
      id={variant === 'filled' ? 'material-symbols-filled' : ''}
      className={composeClasses(className, 'material-symbols-outlined')}
    >
      {name}
    </span>
  )
}

export default GoogleIcon
